import axios from 'axios';
import { parseApiError } from '@/helpers/api-requests';

const actions = {
  async createEquipment(store, equipment) {
    const { dispatch } = store;
    return await axios({
      url: `/v1/equipments`,
      method: 'POST',
      data: { ...equipment },
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getSkill');
        return Promise.resolve(equipment);
      })
      .catch(parseApiError);
  },
  async updateEquipment(store, equipment) {
    const { dispatch, rootGetters } = store;
    if (equipment.sponsor_id && rootGetters['session/permissionsStatus'].isZoneSponsorAllowed) {
      try {
        await dispatch('updateEquipmentSponsor', equipment);
      } catch (err) {
        return Promise.reject(err);
      }
    }
    if ((equipment.status || equipment.status === null) && rootGetters['session/permissionsStatus'].isZoneStatusAllowed) {
      try {
        await dispatch('updateEquipmentStatus', equipment);
      } catch (err) {
        return Promise.reject(err);
      }
    }
    if (rootGetters['session/permissionsStatus'].isZoneUpdateAllowed) {
      return await axios({
        url: `/v1/equipments/${equipment.id}`,
        method: 'PUT',
        data: { ...equipment },
      })
        .then(resp => {
          if (resp.data.error !== undefined) {
            return Promise.reject(resp.data.error);
          }
          dispatch('getSkill');
          return Promise.resolve(equipment);
        })
        .catch(parseApiError);
    } else {
      return Promise.resolve();
    }
  },
  async updateEquipmentStatus(store, equipment) {
    const { dispatch } = store;
    return await axios({
      url: `/v1/equipments/${equipment.id}/status`,
      method: 'POST',
      data: { status: equipment.status },
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getSkill');
        return Promise.resolve(equipment);
      })
      .catch(parseApiError);
  },
  async updateEquipmentSponsor(store, equipment) {
    const { dispatch } = store;
    return await axios({
      url: `/v1/equipments/${equipment.id}/sponsors`,
      method: 'POST',
      data: { sponsor_id: equipment.sponsor_id },
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getSkill');
        return Promise.resolve(equipment);
      })
      .catch(parseApiError);
  },
  async deleteEquipment(store, equipment) {
    const { dispatch } = store;
    return await axios({
      url: `/v1/equipments/${equipment.id}`,
      method: 'DELETE',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getSkill');
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
  async blockEquipments(store) {
    const { rootState, state, dispatch } = store;
    return await axios({
      url: `/v1/events/${rootState.events.event.id}/skills/${state.skill.id}/equipments/block`,
      method: 'POST',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getSkill');
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
  async unblockEquipments(store) {
    const { rootState, state, dispatch } = store;
    return await axios({
      url: `/v1/events/${rootState.events.event.id}/skills/${state.skill.id}/equipments/unblock`,
      method: 'POST',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        dispatch('getSkill');
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
  async getPublicEquipments(store, code) {
    const { commit, state, rootState } = store;
    return await axios({
      url: `/v1/equipments/public/${code}?include=zones,zones.equipments`,
      method: 'GET',
    })
      .then(resp => {
        if (resp.data.error !== undefined) {
          return Promise.reject(resp.data.error);
        }
        commit('setZones', resp.data.data.zones.data);
        commit('setSkill', resp.data.data);
        return Promise.resolve(resp.data.data);
      })
      .catch(parseApiError);
  },
};

export default actions;